var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "banner-container" }, [
      _c("img", {
        staticClass: "banner",
        attrs: { src: _vm.bannerImg, alt: "ogp" },
      }),
    ]),
    _c("div", { staticClass: "text-container" }, [
      _c("div", [
        _c("div", { staticClass: "name-container" }, [
          _c("img", {
            staticClass: "icon",
            attrs: { src: _vm.iconImg, alt: "icon", width: "40", height: "40" },
          }),
          _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.name))]),
        ]),
        _c("div", { staticClass: "comment-container" }, [
          _c("div", { staticClass: "comment" }, [_vm._v(_vm._s(_vm.comment))]),
        ]),
      ]),
      _c("div", [
        _c("div", { staticClass: "match-container" }, [
          _c("div", { staticClass: "match-label" }, [
            _vm.numOfMatchedNovels > 0
              ? _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t("companyCardVerB.matchLabelWithCount", {
                        matched: _vm.numOfMatchedNovels,
                      })
                    ),
                  },
                })
              : _c("div", [
                  _vm._v(_vm._s(_vm.$t("companyCardVerB.matchLabelEmpty"))),
                ]),
          ]),
        ]),
        _c("div", { staticClass: "button-container" }, [
          _c(
            "button",
            {
              staticClass: "button-common-style detail-button",
              on: { click: _vm.onClickOpenDetail },
            },
            [_vm._v(_vm._s(_vm.$t("companyCardVerB.detailButton")))]
          ),
          _c(
            "button",
            {
              staticClass: "button-common-style post-button",
              on: { click: _vm.onClickPost },
            },
            [_vm._v(_vm._s(_vm.$t("companyCardVerB.postButton")))]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }